import { createFileRoute } from '@tanstack/react-router';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';
import { NotionConfigPage } from '@/features/kanban/components/admin/NotionConfigPage';

export const Route = createFileRoute('/_authenticated/admin/notion-config')({
  component: NotionConfigPageRoute,
});

function NotionConfigPageRoute() {
  return (
    <PermissionGate permission={Permission.NOTION_CONFIG}>
      <NotionConfigPage />
    </PermissionGate>
  );
}
